import { createSelector } from '@reduxjs/toolkit';
import { selectActiveVariantId } from '@ff-scene-plugins/gift-redux/selectors/variantSelectors';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { applyPrefab, selectFilteredPrefabs } from '../_redux-prefabs';
import { selectIfPrefabsFitAllVariants } from '../_redux-scene';

export const applyDefaultPrefabForActiveVariant = (dispatch: GiftPdpDispatch, getState: () => GiftPdpState) => {
    const state = getState();
    const prefabsFitAllVariants = selectIfPrefabsFitAllVariants(state);
    if (!prefabsFitAllVariants) {
        const defaultPrefabForVariant = selectDefaultPrefabForActiveVariant(state);
        dispatch(applyPrefab(defaultPrefabForVariant));
    }
};

const selectDefaultPrefabForActiveVariant = createSelector([
    selectFilteredPrefabs,
    selectActiveVariantId
], (prefabs, activeVariantId) => {
    return prefabs.find(p => !p.excludedFromVariants?.includes(activeVariantId))!;
});